export class Config {
  public static bookdemoURL = 'https://connectcoreapi.expertapps.com.sa/api';
  public static loginUrl = Config.bookdemoURL + '/Authenticate/login';
}
